import e, { useState as n, useEffect as G, lazy as J, Suspense as Q } from "react";
import { giftCardCodeAtom as U } from "./index34.mjs";
import { selectedClientDetailsAtom as W } from "./index55.mjs";
import { setCurrentStepAtom as X } from "./index25.mjs";
import { insurancePriceAtom as $ } from "./index62.mjs";
import ee from "./index79.mjs";
import { useSetAtom as te, useAtomValue as a } from "jotai";
import { PaymentType as re } from "./index232.mjs";
import i from "./index267.mjs";
import { useClientDetails as oe } from "./index149.mjs";
import { useErrorAlert as ne } from "./index121.mjs";
import { useErrorHandler as ie } from "./index122.mjs";
import { useHotelConfig as se } from "./index93.mjs";
import { useLocale as ae } from "./index151.mjs";
import { usePayment as ce } from "./index123.mjs";
import { useSalesTermsShow as me, useTermsAndConditionsShow as le, useSalesTermsAndConditions as pe } from "./index102.mjs";
import "@amenitiz/design-system";
import { Toast as ue, ToastState as _e } from "./index90.mjs";
import { track as N } from "./index9.mjs";
import { TRACK_EVENT_TYPE as I, TRACK_EVENT as L } from "./index10.mjs";
import de from "classnames";
import ye from "./index268.mjs";
import { Loader as fe } from "./index11.mjs";
import { getSubscriptionPlanRoot as R } from "./index14.mjs";
const Ee = "#333333", Ve = ({
  cartItems: c,
  giftCards: m,
  optedForInsurance: l
}) => {
  const [D, j] = n([]), [k, K] = n(""), [M, O] = n(""), [w, p] = n(!1), [v, u] = n(!0), [_, d] = n(null), { setClientDetails: y } = oe(), f = te(X), x = a($), E = a(W), S = a(U), { setPayment: z, payment: s } = ce(), Y = ae(), C = ne(), { setShowSalesTerms: H } = me(), { setShowTermsAndConditions: V } = le(), { salesTermsAndConditions: o } = pe(), B = ie(), {
    hotelId: b,
    propertySize: g,
    propertyType: T,
    subscriptionPlan: A,
    clientBookingToken: F
  } = se();
  if (G(() => {
    u(!0);
    const r = () => {
      p(!0), C();
    };
    ee.createStripePaymentIntent(
      {
        items: c,
        gift_cards: m,
        customer: E,
        clientBookingToken: F,
        opted_for_insurance: l,
        gift_card_code: S
      },
      x
    ).then((t) => {
      if (!t.success) {
        if (t.error_code) {
          const q = B(
            t.error_code,
            f
          );
          return p(!0), C(q);
        }
        return r();
      }
      const P = t.data.stripe_express_public_key, h = t.data.client_secret;
      if (!P || !h) {
        r();
        return;
      }
      O(P), K(h), z({
        stripe_object_type: t.data.stripe_object_type,
        intent_object_id: t.data.intent_object_id,
        amount: t.data.amount,
        currency: t.data.currency,
        payment_method: re.AMENITIZ_PAY
      }), y({
        customer_uuid: t.data.customer_uuid
      }), j(t.data.payment_conditions);
    }).catch(() => {
      r();
    }).finally(() => {
      u(!1);
    });
  }, [c, m, l, S]), v)
    return /* @__PURE__ */ e.createElement("div", { "data-testid": "stripe-loading" }, I18n.t("booking_engine.information.stripe_loading"));
  if (w)
    return null;
  const Z = J(
    () => import("@amenitiz/payment-frontend").then((r) => ({
      default: r.StripeElement
    }))
  );
  return /* @__PURE__ */ e.createElement("div", { className: i["apay-container"] }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: de(
        i["booking-summary-content"],
        i["payment-details-text"]
      )
    },
    /* @__PURE__ */ e.createElement(ye, { paymentConditions: D })
  ), s.stripe_object_type ? /* @__PURE__ */ e.createElement(Q, { fallback: /* @__PURE__ */ e.createElement(fe, null) }, /* @__PURE__ */ e.createElement(
    Z,
    {
      locale: Y,
      primaryColor: Ee,
      expressPublicKey: M,
      clientSecret: k,
      country: E.country,
      stripeObjectType: s.stripe_object_type,
      onError: (r) => {
        N(
          L.CLICK,
          I.PAYMENT_DETAILS_CONFIRMED,
          {
            hotel_id: b,
            property_type: T,
            property_size: g,
            subscription_plan: R(A)
          }
        ), d(r.message);
      },
      className: i.stripe_element,
      onSuccess: (r) => {
        N(
          L.CLICK,
          I.PAYMENT_DETAILS_CONFIRMED,
          {
            hotel_id: b,
            property_type: T,
            property_size: g,
            subscription_plan: R(A)
          }
        ), y({
          sales_terms_accepted: r
        }), f(3);
      },
      amount: s.amount,
      currency: s.currency,
      showSalesTerms: o != null && o.sales_terms ? () => H(!0) : void 0,
      showTermsAndConditions: o != null && o.terms_and_conditions ? () => V(!0) : void 0
    }
  )) : null, _ ? /* @__PURE__ */ e.createElement(
    ue,
    {
      index: 0,
      message: /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("p", { className: i["error-title"] }, I18n.t("booking_engine.information.payment_issue")), /* @__PURE__ */ e.createElement("p", { className: i["error-subtitle"] }, _)),
      state: _e.ERROR,
      onClose: () => d(null)
    }
  ) : null);
};
export {
  Ve as StripeContainer
};
